import { LISTING_PROFILE_TAB_APPLICANTS } from '../../../RentalPortal.constants'
import { RentalPortalListingProfileApplicants } from '../RentalPortalListingProfileApplicants'
import { RentalPortalListingProfileDocuments } from '../RentalPortalListingProfileDocuments'
import { RentalPortalListingProfileExpose } from '../RentalPortalListingProfileExpose'
import { RentalPortalListingProfilePublishings } from '../RentalPortalListingProfilePublishings'
import { RentalPortalListingProfileUpdates } from '../RentalPortalListingProfileUpdates'
import { RentalPortalListingProfileViewings } from '../RentalPortalListingProfileViewings'

export const LISTING_PROFILE_TAB_DOCUMENTS = 'documents'

export const LISTING_PROFILE_TAB_OVERVIEW = 'overview'

export const LISTING_PROFILE_TAB_PUBLISHINGS = 'publishings'

export const LISTING_PROFILE_TAB_UPDATES = 'updates'

export const LISTING_PROFILE_TAB_VIEWINGS = 'viewings'

export const QA_NAME_LISTING_PROFILE_TAB_APPLICANTS =
  'listingProfileApplicantsTab'

export const QA_NAME_LISTING_PROFILE_TAB_DOCUMENTS =
  'listingProfileDocumentsTab'

export const QA_NAME_LISTING_PROFILE_TAB_OVERVIEW = 'listingProfileOverviewTab'

export const QA_NAME_LISTING_PROFILE_TAB_PUBLISHINGS =
  'listingProfilePublishingsTab'

export const QA_NAME_LISTING_PROFILE_TAB_UPDATES = 'listingProfileUpdatesTab'

export const QA_NAME_LISTING_PROFILE_TAB_VIEWINGS = 'listingProfileViewingsTab'

export const LISTING_PROFILE_TAB_LIST = [
  {
    Content: RentalPortalListingProfileExpose,
    id: LISTING_PROFILE_TAB_OVERVIEW,
    qaName: QA_NAME_LISTING_PROFILE_TAB_OVERVIEW,
    titleKey: 'RentalPortal.ListingProfileTabOverviewKey',
  },
  {
    Content: RentalPortalListingProfilePublishings,
    counterSection: LISTING_PROFILE_TAB_PUBLISHINGS,
    id: LISTING_PROFILE_TAB_PUBLISHINGS,
    permissionKey: 'can_view_publications',
    qaName: QA_NAME_LISTING_PROFILE_TAB_PUBLISHINGS,
    titleKey: 'RentalPortal.ListingProfileTabPublishingsKey',
  },
  {
    Content: RentalPortalListingProfileApplicants,
    counterSection: LISTING_PROFILE_TAB_APPLICANTS,
    id: LISTING_PROFILE_TAB_APPLICANTS,
    permissionKey: 'can_view_applicants',
    qaName: QA_NAME_LISTING_PROFILE_TAB_APPLICANTS,
    titleKey: 'RentalPortal.ListingProfileTabApplicantsKey',
  },
  {
    Content: RentalPortalListingProfileViewings,
    counterSection: LISTING_PROFILE_TAB_VIEWINGS,
    id: LISTING_PROFILE_TAB_VIEWINGS,
    permissionKey: 'can_view_viewings',
    qaName: QA_NAME_LISTING_PROFILE_TAB_VIEWINGS,
    titleKey: 'RentalPortal.ListingProfileTabViewingsKey',
  },
  {
    Content: RentalPortalListingProfileDocuments,
    counterSection: LISTING_PROFILE_TAB_DOCUMENTS,
    id: LISTING_PROFILE_TAB_DOCUMENTS,
    permissionKey: 'can_view_documents',
    qaName: QA_NAME_LISTING_PROFILE_TAB_DOCUMENTS,
    titleKey: 'RentalPortal.ListingProfileTabDocumentsKey',
  },
  {
    Content: RentalPortalListingProfileUpdates,
    id: LISTING_PROFILE_TAB_UPDATES,
    permissionKey: 'can_view_updates',
    qaName: QA_NAME_LISTING_PROFILE_TAB_UPDATES,
    titleKey: 'RentalPortal.ListingProfileTabUpdatesKey',
  },
]
